import { React, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import TripInput from "../../components/trip-input/TripInput";
import EditTripNav from "../../components/navbar/edittrip-nav/EditTripNav";
import "../NewTrip-page/NewTrip.css";

function EditTrip() {
  const { id } = useParams();
  const [tripData, setTripData] = useState(null);
  useEffect(() => {
    const fetchTrip = async () => {
      try {
        const fetchedData = await axios.get(`https://tripmate-rbck.onrender.com/edit-trip/${id}`);
        setTripData(fetchedData.data);
      } catch (err) {
        console.error("Error fetching data");
      }
    };
    fetchTrip();
  }, [id]);

  return (
    <>
      <div className="trips-page">
        <EditTripNav/>
        <TripInput postRoute={`https://tripmate-rbck.onrender.com/edit-trip/${id}`} initialData={tripData} />
      </div>
    </>
  );
}

export default EditTrip;
